<template>
    <section class="fst-LLMAssistant">
        <div class="admin-content mb-3" v-loading.fullscreen.lock="loading">
            <div class="header">
                <h3>{{$t('admin.llmAssistant.title')}}</h3>
                <el-select v-model="sC"
                           style="width: 405px"
                           value-key="id"
                           popper-class="templateSelect"
                           placeholder="Выберите конфигурацию">
                    <el-option v-for="(tpl, key) in llmNotionConfigs"
                               :label="tpl.name"
                               us :value="tpl"
                               :key="key">
                        <div class="title">{{tpl.name}}</div>
                        <div class="desc" v-if="tpl.description"
                             v-html="tpl.description"></div>
                    </el-option>
                </el-select>

            </div>
            <div class="result">
                <!--                <el-collapse class="params" v-model="visibleSections" accordion>-->
                <!--                    <el-collapse-item title="Подобрать понятия по теме" :name="0">

                                  </el-collapse-item>-->
                <!--                    <el-collapse-item title="Создать понятие" :name="1">-->
                <div class="terms-concepts">
                    <div class="flex-top gap-15">
                        <div class="label">Название:</div>
                        <el-input class="concept"
                                  clearable @keyup.enter.native="handleGenerateTerms"
                                  v-model="generateTerms.concept"></el-input>
                        <el-input v-model="generateTerms.description"
                                  placeholder="Описание понятия"
                                  :rows="4" type="textarea"></el-input>
                        <div class="actionBlock">
                            <!--el-button type="primary" plain @click="handleGenerateTerms">Подобрать термины
                            </el-button-->
                            <el-button type="primary"
                                       :disabled="!generateTerms.concept"
                                       @click="handleGenerateQuery">Создать запрос
                            </el-button>
                            <div class="mt-4">
                                <el-button type="primary"
                                           :disabled="!generateTerms.concept"
                                           plain @click="handleGenerateConcepts()">
                                    Подобрать термины
                                </el-button>
                                <el-button type="primary"
                                           v-if="(generateConcepts.result || []).length"
                                           plain @click="showConcepts = !showConcepts">
                                    <i class="far fa-chevron-left"></i>
                                </el-button>
                            </div>
                        </div>
                    </div>

                    <div class="flex-top gap-15 mt-4" v-if="generateTerms.result">
                        <div class="label">Термины:</div>
                        <el-input class="terms" type="textarea"
                                  :rows="3" readonly
                                  v-model="generateTerms.result"></el-input>
                        <div class="actionBlock"></div>

                    </div>

                    <validate-query v-model="generateQuery.querySci"
                                    @validationComplete="validationComplete"/>
                    <notion-query-block
                            @input="handleChangeNotion"
                            :notion="{
                                    id: null,
                                    name: this.generateTerms.concept,
                                    description: this.generateTerms.description,
                                    querySciencePatents: this.generateQuery.querySci,
                                    queryNewsCompanies: this.generateQuery.queryNews,
                                }"
                            :companiesList="companies"
                    ></notion-query-block>
                    <template v-if="isAllowed">
                        <el-divider>Проверка понятия</el-divider>
                        <query-analysis :config-id="sC.id"
                                        :validation="!validationFalse"
                                        :topic="generateTerms.concept"
                                        :description="generateTerms.description"
                                        :query="generateQuery.querySci"/>
                    </template>


                    <!--  </el-collapse-item> -->
                    <!--                </el-collapse>-->

                </div>
                <el-drawer
                        title="Подобранные термины"
                        :visible.sync="showConcepts"
                        custom-class="llmAssistConcepts"
                        size="30vw"
                        direction="rtl">
                    <table class="table table-button" v-if="(generateConcepts.result || []).length">
                        <tr v-for="(tr,trK) in generateConcepts.result" :key="trK">
                            <td>
                                <el-button type="primary" plain @click="handleSelectConcept(tr)"><i class="far fa-chevron-left"></i></el-button>
                            </td>
                            <td>
                                <div class="concept linkLike" @click="handleSelectConcept(tr)" v-html="tr.concept"></div>
                                <div v-html="tr.description" class="description"></div>
                            </td>
                            <!--td>
                                <el-button type="primary" @click="handleSelectConcept(tr)">Выбрать</el-button>
                            </td-->
                        </tr>
                    </table>

                </el-drawer>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import Mixins from './mixins';
    import NotionQueryBlock from "./NotionQueryBlock";
    import _ from "lodash";
    import QueryAnalysis from "@/components/settings/QueryAnalysis.vue";
    import ValidateQuery from "../../commons/components/ValidateQuery";

    export default {
        name: "LLMAssistant",
        mixins: [Mixins],
        components: {ValidateQuery, QueryAnalysis, NotionQueryBlock},
        computed: {
            ...mapState({
                llmNotionConfigs: state => state.llm.llmNotionConfigs,
                allowedActions: state => state.allowedActions
            }),
            isAllowed() {
                return this.allowedActions.contains('NOTION_ASSISTANT')
            }
        },
        data() {
            return {
                loading: true,
                visibleSections: [],
                sC: {},
                validationFalse: false,
                showConcepts: false,
                generateConcepts: {
                    QUESTION: '',
                    DESCRIPTION: '',
                    result: []
                },
                generateTerms: {
                    concept: '',
                    description: '',
                    result: ''
                },
                generateQuery: {
                    QUESTION: '',
                    result: [],
                    querySci: '',
                    queryNews: '',
                    queryType: 'querySci',
                },
                analyzeQuery: {
                    notionPredicate: '',
                    notionList: [],
                    curNotion: {},
                    TASK: 'оптимизировать запрос',
                    QUERY: '',
                    query: 'querySciencePatents',
                    result: {
                        queryNewsCompanies: {
                            query: '',
                            description: ''
                        },
                        querySciencePatents: {
                            query: '',
                            description: ''
                        }
                    },
                },
                notFound: false,
                notionBak: {},
                queryTypes: ['querySciencePatents', 'queryNewsCompanies'],

            }
        },
        mounted() {
            if (this.userIsAdmin) {
                this.getCompanies().then(() => {
                    this.initData();
                })
            } else {
                this.companies = [this.userInfo.company];
                this.companyName[this.userInfo.company.id] = this.userInfo.company.name;
                this.initData();
            }
        },
        watch: {
            sC(newSc) {
                this.generateQuery.QUESTION = newSc.queryRequirementsBoilerplate || ''
            }
        },
        methods: {
            ...mapActions('llm', ['getLlmNotionConfigs']),
            handleGenerateConcepts() {
                if (this.generateTerms.concept && (_.map(this.generateConcepts.result, 'concept')).includes(this.generateTerms.concept)) {
                    this.showConcepts = true;
                } else {
                    let self = this,
                        query = {
                            "configId": this.sC.id,
                            "parameters": {
                                "QUESTION": this.generateTerms.concept,
                                "DESCRIPTION": this.generateTerms.description
                            }
                        }
                    this.loading = true;
                    this.generateConcepts.result = [];
                    this.$services.notionAssistant.generateConcepts(query).then(resp => {
                        this.loading = false;
                        //console.log('generateConcepts:', resp.data)
                        this.generateConcepts.result = (resp.data.result || []).map(res => {
                            res.concept = _.upperFirst(res.concept) || '';
                            res.description = _.upperFirst(res.description) || '';
                            return res;
                        })
                        // const firstRes = this.generateConcepts.result[0] || {}
                        // this.generateTerms.concept = firstRes.concept;
                        // this.generateTerms.description = firstRes.description;
                        this.generateConcepts.result.unshift({
                            concept: this.generateTerms.concept,
                            description: this.generateTerms.description,
                        })
                        this.showConcepts = true;
                    }, err => {
                        self.handleError(err);
                    })
                }
            },
            handleGenerateTerms() {
                let self = this,
                    query = {
                        "configId": this.sC.id,
                        "parameters": {
                            "QUESTION": this.generateTerms.concept,
                            "DESCRIPTION": this.generateTerms.description
                        }
                    }
                this.loading = true;
                this.generateTerms.result = '';
                this.$services.notionAssistant.generateTerms(query).then(resp => {
                    this.loading = false;
                    //console.log('generateTerms:', resp.data)
                    this.generateTerms.result = (resp.data.result || []).map(res => {
                        return `"${res.term}"`;
                    }).join(' ');
                }, err => {
                    self.handleError(err);
                })
            },
            handleGenerateQuery() {
                let self = this,
                    query = {
                        "configId": this.sC.id,
                        "parameters": {
                            // "QUESTION": this.generateQuery.QUESTION
                            "TOPIC": this.generateTerms.concept,
                            "DESCRIPTION": this.generateTerms.description
                        }
                    }
                this.loading = true;
                this.generateTerms.result = '';
                this.$services.notionAssistant.generateQuery(query).then(resp => {
                    this.loading = false;
                    // console.log('generateQuery:', resp.data)
                    this.generateQuery[this.generateQuery.queryType] = resp.data.result;
                }, err => {
                    self.handleError(err);
                })
            },
            handleChangeNotion(notion) {
                this.generateQuery.querySci = notion.querySciencePatents;
            },
            validationComplete(result) {
                this.validationFalse = !result.status;
            },
            handleFindNotion() {
                let _query = {
                    count: 50,
                    offset: 0,
                    order: [
                        {field: 'predicate:name', type: 'ASC'},
                        {field: 'predicate:description', type: 'ASC'},
                        {field: 'predicate:creator', type: 'ASC'},
                    ],
                    predicate: {
                        "type": "LIKE",
                        "caseInsensitive": true,
                        "value": this.analyzeQuery.notionPredicate
                    }
                };
                this.loading = true;
                this.notFound = false;
                this.analyzeQuery.curNotion = {}
                return this.$services.notions.list(_query).then(resp => {
                    this.analyzeQuery.notionList = resp.data.list;
                    this.notFound = !resp.data.total
                    setTimeout(() => {
                        this.loading = false;
                    }, 350)
                })
            },
            handleAnalyzeIt() {
                let self = this;
                this.loading = true;
                this.generateTerms.result = '';
                this.queryTypes.forEach(type => {
                    let query = {
                        "configId": this.sC.id,
                        "parameters": {
                            "QUERY": this.analyzeQuery.curNotion[type],
                            "TASK": this.analyzeQuery.TASK
                        }
                    }
                    this.$services.notionAssistant.analyzeQuery(query).then(resp => {
                        this.loading = false;
                        console.log('analyzeQuery-', type, resp.data)
                        this.analyzeQuery.result[type] = (resp.data.result || [])[0] || {};
                        this.analyzeQuery.curNotion[type] = this.analyzeQuery.result[type].query;
                        this.analyzeQuery.curNotion[`${type}Desc`] = this.analyzeQuery.result[type].description;
                    }, err => {
                        self.handleError(err);
                    })
                })
            },
            handleSelectNotion(notion) {
                this.analyzeQuery.curNotion = notion;
                this.analyzeQuery.notionPredicate = notion.name;
                this.analyzeQuery.notionList = [];
                this.notionBak = _.cloneDeep(this.analyzeQuery.curNotion);

            },
            handleSelectConcept(item) {
                this.visibleSections = [1];
                this.generateTerms.concept = item.concept;
                this.generateTerms.description = item.description;

                this.showConcepts = false;
            },
            handleReset() {
                this.analyzeQuery.curNotion = _.cloneDeep(this.notionBak);
            },
            handleError(err) {
                let self = this;
                if (err.response && err.response.data.message) {
                    let _msg = ((((err.response?.data?.message || '').split('number 0') || ['', ''])[1] || err.response?.data?.message) || '').replace(/\^/g, '')
                    this.$alert(_msg, 'Внимание!');
                }
                self.loading = false;
            },
            initData() {
                Promise.all([this.getLlmNotionConfigs({prepare: {target: this.$el}})]).then(() => {
                    //console.log('llmConfs::', this.llmNotionConfigs)
                    this.loading = false;
                    this.sC = (this.llmNotionConfigs || [])[0] || {}
                })

            },
        }
    }
</script>

<style lang="scss">
    .fst-LLMAssistant {
        .header {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            margin-bottom: 30px;

            h3 {
                margin: 0;
            }
        }

        .text-button {
            display: flex;
            align-items: center;
            gap: 15px;
        }

        .actionBlock {
            flex: 0 0 240px;
        }

        .table-button {
            width: 100%;

            td {
                padding: 7px 10px;
                line-height: 1.4;
                .concept{
                    font-weight: 500;
                    font-size: 15px;
                }

                .description {
                    font-size: 13px;
                    line-height: 1.3;
                    margin-top: 2px;
                }
            }
        }

        .result {
            display: flex;
            gap: 20px;

            .concept {
                flex: 0 0 350px;

                input {
                    font-weight: 500;
                }
                .el-input__suffix{
                    height: 32px;
                }
            }

            .label {
                font-weight: 500;
                padding: 3px 0 0 0;
                font-size: 0.825rem;
                flex: 0 0 70px;
            }

        }

        .text__highlight {
            background: #307ff263;
            font-weight: 700;
            padding: 0 1px;
        }

        .analysisControl {
            display: flex;
            align-items: center;
            gap: 15px;

            label {
                font-weight: 500;
                margin-right: 4px;
            }
        }

        .fst-ValidateQuery {
            position: relative;

            .gotErrorMarks i {
                top: 57px;
                left: -11px;
                z-index: 50000;
            }
        }

        .terms-concepts {
            flex: 1;

            .actionBlock {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
            }
        }
    }

    .llmAssistConcepts {
        .el-drawer__header {
            margin: 0;
            padding-bottom: 20px;
            font-size: 1.2rem;
            font-weight: 500;
        }

        .el-drawer__body {
            padding: 0 15px;
            overflow: hidden auto;
        }
    }
</style>